import React from 'react';
import './EditItem.scss';
import { FaPencilAlt } from 'react-icons/fa';

interface IEditItemProps {
	onClick?: () => void;
}

export const EditItem = ({ onClick }: IEditItemProps): JSX.Element => {
	return (
		<div className="editItemContainer" onClick={onClick}>
			<FaPencilAlt />
		</div>
	);
};
